



















































import Vue from "vue";
import { Component, Prop, Watch } from 'vue-property-decorator';
import draggable from "vuedraggable";
import NavNode from "@/services/NavigationNode";
import uid from "@/utils/uid";
import TreeExpander from '@/utils/TreeExpander';

@Component({
	name: 'LibTreeItem',
	components: {
		draggable,
	},
	computed: {
	}
})
export default class LibTreeItem extends Vue {
	@Prop() item!: NavNode;

	isOpen = true;

	itemListMaxHeight: number | null = null;

	get isFolder() {
		return this.item.siteMap.canHaveChildren;
	}

	get isFolderOpen() {
		return this.isOpen && this.item.siteMap.canHaveChildren;
	}

	@Watch('isFolderOpen')
	updateExpandedHeight() {
		if (!this.isFolderOpen) {
			this.itemListMaxHeight = TreeExpander.getTreeHeight(this.item);
		}
	}

	created() {
		this.itemListMaxHeight = TreeExpander.getTreeMaxHeight(this.item);
	}

	get itemListStyle() {
		const style: { maxHeight?: string } = {};

		if (this.isFolderOpen) {
			style.maxHeight = ((this.itemListMaxHeight || 0) + 20) + 'px';
		}

		return style;
	}

	cloned(a: NavNode) {
		const e = JSON.parse(JSON.stringify(a));
		e.isRootNode = true;
		uid([e]);
		this.$store.dispatch("setSelected", e.uid);
		return e;
	}
}

// for recursion recognizing itself in "prod" compile mode
// Vue.component('LibTreeItem', LibTreeItem); in case `name` does not work.
